import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PromoCodeBaseEffect } from './promo-code-base.effect';
import { promoCodeBaseReducer } from './promo-code-base.reducer';
import { FEATURE_NAME } from './promo-code-base.constant';

@NgModule({
  imports: [
    EffectsModule.forFeature([ PromoCodeBaseEffect ]),
    StoreModule.forFeature(FEATURE_NAME, promoCodeBaseReducer)
  ]
})
export class PromoCodeBaseModule {

}
